import React, { useState } from 'react';
import { useTheme } from '../../context/ThemeContext';
import { getDialogStyles } from './styles';
import { InstallGuide } from './InstallGuide';

function SettingsDialog({ 
  isOpen, 
  onClose, 
  activeGroup, 
  groups, 
  onGroupChange,
  onManageCards,
  isMuted,
  onToggleMute,
  onInstallClick 
}) {
  const { isDark, toggleTheme, colors } = useTheme();
  const [showInstallGuide, setShowInstallGuide] = useState(false);
  
  if (!isOpen) return null;

  const styles = getDialogStyles(colors);

  if (showInstallGuide) {
    return (
      <InstallGuide 
        onBack={() => setShowInstallGuide(false)} 
        onClose={onClose}
        colors={colors}
      />
    );
  }

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.dialog} onClick={e => e.stopPropagation()}>
        {groups.length > 0 && (
          <div style={styles.selectContainer}>
            <label style={styles.selectLabel}>Select Topic</label>
            <select
              value={activeGroup}
              onChange={onGroupChange}
              style={styles.select}
            >
            {groups.map(group => (
              <option key={group.id} value={group.id}>
                {`${group.topic} - ${group.difficulty}`}
              </option>
            ))}
            </select>
          </div>
        )}
        
        <div style={styles.menuGrid}>
          <button onClick={onManageCards} style={styles.menuButton}>
            <span style={styles.menuIcon}>+</span>
            <span style={styles.menuText}>Add & Manage Cards</span>
          </button>
          
          <button onClick={onToggleMute} style={styles.menuButton}>
            <span style={styles.menuIcon}>{isMuted ? "🔇" : "🔊"}</span>
            <span style={styles.menuText}>{isMuted ? "Unmute" : "Mute"} Sound</span>
          </button>
          
          <button onClick={() => setShowInstallGuide(true)} style={styles.menuButton}>
            <span style={styles.menuIcon}>⬇️</span>
            <span style={styles.menuText}>Install App</span>
          </button>

          <button 
            onClick={toggleTheme} 
            style={styles.menuButton}
          >
            <span style={styles.menuIcon}>{isDark ? "🌙" : "☀️"}</span>
            <span style={styles.menuText}>{isDark ? "Light Mode" : "Dark Mode"}</span>
          </button>
        </div>

        <button onClick={onClose} style={styles.closeButton}>
          Close
        </button>
      </div>
    </div>
  );
}

export default SettingsDialog;
